import API from 'services/api';

export const getContractPaymentModels = () => API.get('/api/payment-models');
